import { IFormThingsToImprove } from 'legacy/lut/classes/models/partner360/IFormThingsToImprove'
import { GPKeyInitiativesEditor } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/GPKeyInitiativesEditor'
import { IGPKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/models/gpKeyInitiativeForm'
import { isGlobalPartnerPlanPage } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/helpers/isGlobalPartnerPlanPage'
import { KeyInitiativeEditor } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditor/KeyInitiativeEditor'
import {
  IFormKIEditor,
  IGPFormKIEditor,
} from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/models'
import { useLocation } from 'react-router-dom'

import MeasureController from 'core/analytics/MeasureController'

interface IProps {
  initialState?: Partial<IFormKIEditor | IGPFormKIEditor>
  isDialogOpened: boolean
  isDataInsightPresent?: boolean
  metrics: MeasureController
  isDataInsightTab?: boolean
  isAmplifyImpactInfoSection?: boolean
  keyObjectivesFilter?: string

  onLoadingStateChange?: (isLoading: boolean) => void
  onEditCancel: () => void
  onUpdateFinished: (newData: IFormThingsToImprove[] | IGPKeyInitiativeForm[]) => void
}

export const KeyInitiativeEditorWrapper = (props: IProps) => {
  const location = useLocation()
  if (!props.isDialogOpened) {
    return null
  }

  if (isGlobalPartnerPlanPage(location.pathname)) {
    // @ts-ignore
    return <GPKeyInitiativesEditor {...props} />
  }
  return (
    <KeyInitiativeEditor {...props} isDataInsightPresent={props.isDataInsightPresent || false} />
  )
}
